<template>
  <div :class="total ===0 ?'item-box-content':'item-box-content-bottom'">
    <div>
      <div style="text-align:right;">
        <el-button @click="toExport" type="primary" style="margin-bottom:10px;">导出产品</el-button>
        <el-button @click="moveInPlan"  style="margin-bottom:10px;">移入采购区</el-button>
      </div>
      <el-table
        border
        ref="tableRef"
        :data="dataList"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChange"
        @row-dblclick="RowDbclick"
      >
        <template slot="empty">
          <no-data :nodata="`nodataPurchase`">暂无待采购产品！</no-data>
        </template>
        <el-table-column fixed type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="ocspCode" label="工单编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="stockupType" label="备货方式"></el-table-column>
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column prop="cbExtimeValue" label="货期">
          <template slot-scope="scope">{{scope.row.cbExtimeValue+'天'}}</template>
        </el-table-column>
        <el-table-column prop="stockupCount" label="数量"></el-table-column>
        <el-table-column prop="cbPrice" label="采购单价">
          <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column prop label="采购总额">
          <template slot-scope="scope">
            {{
            ( scope.row.stockupCount * scope.row.cbPrice)|priceFilterNum
            }}
          </template>
        </el-table-column>
        <el-table-column prop='createUser' label="发起人"></el-table-column>
        <el-table-column prop="cbPriceSource" label="询价来源">
          <template slot-scope="scope">
            {{
            cbPriceSource[
            scope.row.cbPriceSource - 1
            ]
            }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="suName" label="询价供应商"></el-table-column>
        <el-table-column show-overflow-tooltip prop="storageName" label="备货地址"></el-table-column>
        <el-table-column prop="deliveryTime" label="预计发货时间" width="140px">
          <template slot-scope="scope">{{scope.row.deliveryTime|dateFilter}}</template>
        </el-table-column>
        <!-- <el-table-column  label="操作">
          <template slot-scope="scope">
            <el-button type='text' v-if="scope.row.stockupType === '直发备货'" @click="edit(scope.row)" >修改备货方式</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination" v-show="total!==0" style="margin-top:20px;">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
     <open-or-close
      @onUpdataState="onUpdataState"
      content="备货方式改为入库备货后将不可更改，是否修改为入库备货？"
      title="修改备货方式"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
import pagination from '@/components/pagination'
import { deepClone } from '@/util'
import noData from '@/components/module/noData'
import OpenOrClose from '@/components/OpenOrClose/index'

export default {
  props: ['dataList', 'currentPage', 'pageSize', 'total'],
  components: {
    pagination: pagination,
    noData,
    'open-or-close': OpenOrClose
  },
  data () {
    return {

      listStockUp: [{}],
      cbPriceSource: ['系统', '人工', '特价审批', '其他', '库存'],
      waitMoveList: []
    }
  },
  mounted () {
  },
  methods: {
    RowDbclick (row) {
      this.$emit('waitMoveList', [row])
      // this.waitMoveList = []
    },
    moveInPlan () {
      if (this.waitMoveList.length !== 0) {
        this.$emit('waitMoveList', deepClone(this.waitMoveList))
        // this.waitMoveList = []
      } else {
        this.$message.error('请选中要移入采购区的产品！')
      }
    },
    handleSelectionChange (value) {
      this.waitMoveList = value
    },
    handleSizeChange (val) {
      this.$emit('handleSizeChange', val)
    },
    // 页码
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 导出清单
    toExport() {
      this.$emit('toExport')
    },
    // 修改备货方式
    edit(row) {
      this.$refs.openOrCloseRefs.onInitial()
    },
    onUpdataState() {

    }

  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
</script>
<style lang="scss" scoped>
.item-box-content-bottom {
  background-color: #fff;
  margin-bottom: 20px;
  padding: 20px 20px 0 20px;
  font-size: 14px;
  border-radius: 4px;

  .config-instruction {
    padding: 10px 0px 10px 20px;
  }
}
</style>
